import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useStore } from 'react-redux';
import { useParams } from 'react-router-dom';

import BottomBar from './BottomBar';
import styles from './index.module.scss';
import Map2D from './Map2D';
import Map3D from './Map3D';
import SideBarLeft from './SideBarLeft';
import SideBarRight from './SideBarRight';

import actions from '@/actions';
import AddTakeoffModal from '@/components/modals/AddTakeoff';
import SelectSpecsModal from '@/components/modals/SelectSpecs';
import StartMissionHubModal from '@/components/modals/StartMissionHub';
import WrongMissionModal from '@/components/modals/WrongMission';
import Bar from '@/components/ui/Bar';
import Callout from '@/components/ui/Callout';
import ContainerFullHeight from '@/components/ui/ContainerFullHeight';
import MapSelector from '@/components/ui/MapSelector';
import TopBar from '@/components/ui/TopBar';
import ZonesSelector from '@/components/ui/ZonesSelector';
import { getMission } from '@/helpers/Requester';
import useCollisionChecker from '@/hooks/useCollisionChecker';
import useEditorLabels from '@/hooks/useEditorLabels';
import useEditorMarkers from '@/hooks/useEditorMarkers';
import useEditorPath from '@/hooks/useEditorPath';
import useEditorShoots from '@/hooks/useEditorShoots';
import useLoadUser from '@/hooks/useLoadUser';
import { ModalService as modal } from '@/libs/Modal';

const cx = classNames.bind(styles);

const Page = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const params = useParams();

  // 계정 조회
  useLoadUser();

  useEditorLabels();
  useEditorMarkers();
  useEditorPath();
  useEditorShoots();
  useCollisionChecker();

  useEffect(() => {
    // ~/mission-hub
    if (!params.id) {
      modal.show(StartMissionHubModal);
      return;
    }
    // ~/mission-hub/new
    else if (params.id === 'new') {
      const needSpecs = Object.values(store.getState().mission.json.specs).some((value) => value === null);
      if (needSpecs) {
        modal.show(SelectSpecsModal);
      } else {
        modal.show(AddTakeoffModal);
      }
      return;
    }

    getMission(params.id).then(({ success, data }) => {
      if (success && data) {
        dispatch(actions.mission.load(data));
      } else {
        modal.show(WrongMissionModal);
      }
    });
  }, [params.id]);

  return (
    <>
      <Helmet>
        <title>M1UCS | Mission Hub</title>
      </Helmet>
      <ContainerFullHeight className={cx('container')}>
        <TopBar>
          <MapSelector />
          {process.env.REACT_APP_USE_VWORLD_ZONES === 'true' && (
            <>
              <Bar size={20} />
              <ZonesSelector />
            </>
          )}
        </TopBar>
        <div className={cx('content')}>
          <Map2D />
          <Map3D />
          <div className={cx(['sidebar', 'left'])}>
            <SideBarLeft />
          </div>
          <div className={cx(['sidebar', 'right'])}>
            <SideBarRight />
          </div>
        </div>
        <BottomBar />
        <Callout />
      </ContainerFullHeight>
    </>
  );
};

export default Page;
